<template>
  <OurModal v-model="isShownModal" :title="$t('title.fleaMarket.filters')" mobile-footer-reverse>
    <FilterForm ref="filterForm" v-model="form" />

    <template #footer-left>
      <OurButton :text="$t('button.apply')" @click="onClickApplyButton" />

      <OurButton :text="$t('button.close')" variant="secondary" @click="onClickCloseButton" />
    </template>

    <template #footer-right>
      <OurButton
        class="button"
        :text="$t('button.clear')"
        variant="thirdary"
        @click="onClickCleanButton"
      />
    </template>
  </OurModal>
</template>

<script>
import { mapState, mapMutations } from "vuex";

import FilterForm from "./components/FilterForm";

export default {
  name: "FilterModal",

  components: {
    FilterForm,
  },

  props: {
    show: {
      type: Boolean,
      default: false,
    },
  },

  data() {
    return {
      form: {
        "companies.id": "",
        "companies.name": "",
        "oneCEmployees.name": "",
        accessGroupId: "",
        customerId: "",
        status: "",
        taxNumber: "",
      },
    };
  },

  computed: {
    ...mapState("dealerCompany", ["filtersForm", "companies"]),

    isShownModal: {
      get() {
        return this.show;
      },
      set(value) {
        this.$emit("update:show", value);
      },
    },
  },

  watch: {
    isShownModal: "onChangeShownModal",
  },

  methods: {
    ...mapMutations("dealerCompany", ["SET_FILTERS_FORM"]),

    onChangeShownModal() {
      if (this.isShownModal) {
        if (this.filtersForm) {
          this.getForm();
        }
      } else {
        this.cleanForm();
      }
    },

    getForm() {
      this.form = { ...this.filtersForm };
    },

    cleanForm() {
      this.form = {
        "companies.id": "",
        "companies.name": "",
        "oneCEmployees.name": "",
        accessGroupId: "",
        status: "",
        taxNumber: "",
      };
    },

    closeModal() {
      this.isShownModal = false;
      this.cleanForm();
    },

    onClickCloseButton() {
      this.closeModal();
    },

    onClickApplyButton() {
      this.$refs.filterForm.onChangeForm();

      if (this.$refs.filterForm.isValid) {
        this.setFiltersForm();
        this.closeModal();
      }
    },

    onClickCleanButton() {
      this.cleanForm();
    },

    setFiltersForm() {
      this.companies.find((company) => {
        if (company.id === this.form["companies.name"]) {
          this.form["companies.name"] = company.label;
        }
      });

      const form = { ...this.form };

      this.SET_FILTERS_FORM(form);
    },
  },
};
</script>
